module.exports = __webpack_public_path__ + "static/img/icon_arrows@2x.d84be6e2.png";